export default {
  setTracker(o) {
    let obj = {
      // 产品
      $product: "网校通",
      // 应用
      $application: "网校通pc站",
      // 版本
      $app_version: "1.0",
      // 用户ID
      $user_id: o.user_id,
      // 所属学校ID
      $school_id: o.school_id,
      // 是否B端用户 0/1
      $is_tob: o.is_tob,
      // B端产品权限
      $tob_rights: o.tob_rights,
      // C端产品权限
      $toc_rights: o.toc_rights,
      // 学段
      $stage: o.stage_id,
      // 学科
      $subject: o.subject_id,
      // 教材版本
      $book_version: o.version_id,
      // 是否单页面
      $single_page_app: true,
    };
    o && o["source"] ? (obj.$source = o["source"]) : null;
    return obj;
  },
  constructTracker(obj, user, isInIframe) {
    let tobRight = [];
    if (user && user.allRoles) {
      for (let role of user.allRoles) {
        tobRight.push(role.simpleName);
      }
    }
    let objParams = {
      user_id: user.userId,
      school_id: user.schoolId,
      is_tob: "1",
      tob_rights: tobRight.join(","),
      toc_rights: "",
      stage_id: obj.stageId,
      subject_id: obj.subjectId,
      version_id: obj.versionId,
    };
    isInIframe ? (objParams.source = "xep") : null;
    window.xkwTracker = this.setTracker(objParams);
  },
  tracker() {
    // console.log("埋点");
    const timeStamp = new Date().getTime();
    // const trackerUrl = "//io.xkw.com/io/tracker.js?" + timeStamp;
    const trackerUrl =
      "//zxxkstatic.zxxk.com/ued/sdk/tracker-sdk.js?" + timeStamp;
    const tracker = document.createElement("script");
    tracker.setAttribute("src", trackerUrl);
    const body = document.body;
    body.appendChild(tracker);
  },
  handleSendTongji(data) {
    try {
      if (window.easyData) {
        // console.log(window.easyData);
        window.easyData.send(data);
      } else {
        const interval = window.setInterval(() => {
          if (window.easyData) {
            // console.log(window.easyData);
            window.easyData.send(data);
            window.clearInterval(interval);
          }
        }, 1000);
      }
    } catch (error) {}
  },
};
